export default __webpack_public_path__ + "static/media/spark_14.7e1e49b9.png";